<template>
  <div>
    <Operator
      :disabled="disabled"
      :operators="operators"
      :value.sync="compareType"/>
    <sFormItem
      v-if="$_showParametersWithOperator"
      class="parameters"
      :disabled="disabled"
      prop="parameters"
      :rules="parametersRules">
      <div class="flex">
        <TimeSpan
          :disabled="disabled"
          :second="false"
          :value.sync="parameters"/>
      </div>
    </sFormItem>
  </div>
</template>
<script>
import TimeSpan from 'components/common/TimeSpan.vue'
import Operator from 'components/automation/conditions/default/operator.vue'
import automations from 'mixins/automations.js'

export default {
  name: 'simpleFieldTimeSpan',
  mixins: [ automations ],
  data() {
    const that = this
    return {
      parametersRules: {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          if (!that.parameters?.length) {
            callback(new Error(that.$t('Validate.Required')))
          }
          callback()
        },
      },
    }
  },
  computed: {
    compareType: {
      get() {
        if (!this.value?.compareType) {
          return null
        }
        return this.value.compareType
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)
        result.compareType = newValue
        if (!this.$_showParametersWithOperator) {
          result.parameters = null
        }
        this.$emit('update:value', result)
      }
    },
    parameters: {
      get() {
        if (!this.value?.parameters) {
          return null
        }
        let parameters
        try {
          const parseParam = JSON.parse(this.value.parameters) || []
          parameters = Array.isArray(parseParam) ? parseParam[0] : null
        } catch {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Tenders.ErrorConditionParams'),
            showClose: true,
            progress: true,
          })
          parameters = null
        }
        if (this.mode === 'Number' || this.mode === 'Decimal') {
          return +(parameters || '0')
        }
        return parameters
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)

        result.parameters = JSON.stringify([newValue])
        this.$emit('update:value', result)
      }
    },
  },
  components: {
    Operator,
    TimeSpan
  },
  watch: {
    $_showParametersWithOperator: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue && !newValue) {
          this.parameters = null
        }
      }
    }
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    }
  },
}
</script>
